<!-- * ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties
* and other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the applicable
* third party licensors or the open source community as the case may be and nothing here transfers the rights to the third party
* and open source components, except as expressly permitted. Any unauthorized reproduction, storage, transmission in any
* form or by any means (including without limitation to electronic, mechanical, printing, photocopying, recording or
* otherwise), or any distribution of this Program, or any portion of it, may result in severe civil and criminal penalties, and will be
* prosecuted to the maximum extent possible under the law. -->
<mat-expansion-panel [disabled]="isDisabled" hideToggle="true"
  (opened)="isPanelOpened = true"
  (closed)="isPanelOpened = false">
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{title}}
    </mat-panel-title>
    <mat-panel-description>
      {{description}}
      <span class="spacer"></span>
      @if (!isPanelOpened) {
        <mat-icon>add_circle_outline</mat-icon>
      }
      @if (isPanelOpened) {
        <mat-icon>remove_circle_outline</mat-icon>
      }
    </mat-panel-description>
  </mat-expansion-panel-header>

  <ng-template matExpansionPanelContent>
    @if (showContentAsTable && dataSourceSize>0) {
      <mat-table #table [dataSource]="dataSource"
        class="mat-elevation-z5">
        <ng-container matColumnDef="quoteRequestId">
          <mat-header-cell *matHeaderCellDef> Request Number </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <a [href]="generateLinks('quoteRequestId',element.id)">{{element.quoteRequestId}}</a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="requestName">
          <mat-header-cell *matHeaderCellDef> Request Name </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{element.requestName}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="displayStatus">
          <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.displayStatus}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="respondByDate">
          <mat-header-cell *matHeaderCellDef> Respond By Date </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{element.respondByDate | date}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="assignedTo">
          <mat-header-cell *matHeaderCellDef> Assigned To </mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.assignedTo}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="submittedDate">
          <mat-header-cell *matHeaderCellDef> Submitted Date </mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.submittedDate}}</mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedFields"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedFields;"></mat-row>
      </mat-table>
    }
    @if (dataSourceSize>0) {
      <mat-paginator #paginator [pageIndex]="initialPageIndex" [pageSize]="contentTablePageSize" [pageSizeOptions]="contentTablePageSizeOptions" [length]="dataSourceSize" class="mat-elevation-z1" (page)="paginationEvent($event)">
      </mat-paginator>
    }
  </ng-template>
  @if (showActionBar) {
    <mat-action-row>
      <button mat-button>Click me</button>
    </mat-action-row>
  }
</mat-expansion-panel>


